import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

import { CreditsPill, DurationPill } from '@/components';
import { ComplianceTypes } from '@/constants';
import { selectUserCompliance } from '@/store';

interface CreditsDurationInfoProps {
  credits: number;
  duration: number;
  durationPlayed?: number;
}

export const CreditsDurationInfo = ({
  credits,
  duration,
  durationPlayed,
}: CreditsDurationInfoProps) => {
  const compliance = useSelector(selectUserCompliance);
  const theme = useTheme();

  if (compliance !== ComplianceTypes.CPE || durationPlayed! > 0) {
    return (
      <DurationPill
        duration={duration}
        longForm={false}
        color={theme.palette.text.main}
      />
    );
  }

  return <CreditsPill credits={credits} color={theme.palette.text.main} />;
};
